import _extends from "@babel/runtime/helpers/extends";
import React, { memo } from 'react';
import { Link as KitLink } from '@beef/ui-kit';
import classNames from 'classnames/bind';
import style from "./styles.pcss";
import { AnalyticsPusherActionBar } from "../../../../utils/analytics";
var cn = classNames.bind(style);
export var Link = /*#__PURE__*/memo(function (props) {
  var handleClick = function handleClick() {
    AnalyticsPusherActionBar.pushClickEvent(props.href);
    AnalyticsPusherActionBar.pushReachGoal(props.href, props.blockIndex);
  };
  return /*#__PURE__*/React.createElement("div", {
    className: cn('link'),
    "data-t-id": "components-Link"
  }, /*#__PURE__*/React.createElement(KitLink, _extends({}, props, {
    buttonSize: "m",
    isFullWidth: true,
    isNoUnderline: true,
    onClick: handleClick,
    variant: "button"
  }), props.text));
});
Link.displayName = Link.name;